var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.filteredItems.length
    ? _c(
        "div",
        { ref: "carousel", staticClass: "owl-carousel image-carousel" },
        _vm._l(_vm.filteredItems, function(item) {
          return _c("div", { key: item.id, staticClass: "item" }, [
            _c("img", {
              staticClass: "img-fluid lazyload",
              attrs: {
                "data-src":
                  "https://dyn.v-office.com/image/mx/" + item.id + ".webp",
                alt: item.titles && item.titles.de ? item.titles.de : ""
              }
            })
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }